

(function modal () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "modal";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
    })

    })()